import React from 'react';
import axios from 'axios';
import './App.css';
import { AuthProvider } from './context/AuthProvider';
import { AlertProvider } from './context/AlertProvider';
import { LoadingProvider } from './context/LoadingProvider';
import { SelectStationProvider } from './context/SelectOptionProvider';
import AppRoutes from './AppRoutes';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

const App = () => {
  axios.defaults.withCredentials = true;

  return (
    <AuthProvider>
      <AlertProvider>
        <LoadingProvider>
          <SelectStationProvider>
            <AppRoutes />
          </SelectStationProvider>
        </LoadingProvider>
      </AlertProvider>
    </AuthProvider>
  );
};

export default App;
